import { getUserSelector } from '../appContainer/selectors';
import { exportedStore } from '../store/configureStore';

/* eslint-disable no-undef */
export const pushToGtm = (eventName, eventData = {}) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const state = exportedStore.store.getState();
  const user = getUserSelector(state);

  if (dataLayer && dataLayer.push) {
    dataLayer.push({
      event: eventName,
      user_id: user.uuid,
      user_name: user.userName,
      user_email: user.email,
      user_role: user.role,
      page_name: document.title,
      page_path: window.location.pathname,
      ...(eventData || {}),
    });
  }
};
